var React = require('react');

function IcVideo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 16V8L16 12L10 16Z","fill":"#181919","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 6H4V18H20V6ZM4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4Z","fill":"#181919","key":1})]);
}

IcVideo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcVideo;

IcVideo.default = IcVideo;
